import { ApiClient, objectToQueryString } from "../ApiClient";
import config from "../utils/config";
class AuctionV2ApiClient {
    constructor() {
        this.apiClient = new ApiClient(`${config.gatewayApiUrl}/v2/auctions`);
    }
    searchItems(query, abort) {
        return this.apiClient.get(`/items?${objectToQueryString(query)}`, abort);
    }
    bidLot(lotId, request) {
        return this.apiClient.post(`/items/${lotId}/bid`, request);
    }
    getItem(lotId) {
        return this.apiClient.get(`/items/${lotId}`);
    }
    getUserBids(query) {
        return this.apiClient.get(`/bids?${objectToQueryString(query)}`);
    }
    getUserBidsTotal() {
        return this.apiClient.get("/bids/total");
    }
    getWatchedItems(objectsType, sortOrder) {
        return this.apiClient.get(`/watched/items?objectsType=${objectsType}&sortOrder=${sortOrder}`);
    }
    addWatchedItem(request) {
        return this.apiClient.post("/watched/items", request);
    }
    removeWatchedItem(id) {
        return this.apiClient.delete(`/watched/items/${id}`, null);
    }
    getItemHistory(lotId) {
        return this.apiClient.get(`/items/${lotId}/history`);
    }
}
export const auctionV2ApiClient = new AuctionV2ApiClient();
export default auctionV2ApiClient;
